import { FilterDescriptor } from '@progress/kendo-data-query';

export const viewDepartmentFilters: { filters: FilterDescriptor[] }[] = [
  {
    filters: [],
  },
  {
    filters: [{ field: 'isDeleted', value: true, operator: 'neq' }],
  },
  {
    filters: [{ field: 'isDeleted', value: true, operator: 'eq' }],
  },
];
